// const contractCloseEstimated = function
function contractCloseEstimated(UserInfo, filtersUtils, DateUtils) {
    return {
        restrict: 'AE',
        scope: {},
        //templateUrl: require('../../static/contracts/templates/actions-dropdown-close-estimated-period.html'),
        templateUrl: require('../../templates/actions-dropdown-close-estimated-period.html'),
        controller: function ($scope, $http, $rootScope, Alert, $filter, Task) {
            /***********************************************************************************************************
             * Controller Attributes
             ***********************************************************************************************************/
            var $translate = $filter('translate');

            /***********************************************************************************************************
             * Scope Attributes
             ***********************************************************************************************************/
            $scope.listToUpdate = [];

            $scope.hasPerm = true; // UserInfo.hasPerm('invoices.can_create_estimated_invoices');

            /***********************************************************************************************************
             * Scope Watchers
             ***********************************************************************************************************/
            $scope.$on("selectedItemsChange", function (e, selectedItemsChange) {
                $scope.listToUpdate = selectedItemsChange;
            });

            $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
                $scope.counter = selectedCounterChange;
            });

            /***********************************************************************************************************
             * Controller Methods
             ***********************************************************************************************************/

            /***********************************************************************************************************
             * Scope Methods
             ***********************************************************************************************************/
            $scope.closeEstimatedPeriod = function () {
                var ids = filtersUtils.getItemsToDownloadToInt($scope.listToUpdate);
                var json = {
                    ids: ids
                };
                var task = new Task();
                task.type = 'CEST';
                task.params = json;
                task.start().then(function (data, status, headers, config) {
                    Alert.createAlert('success', $translate('CONTRACTS.Close estimated invoice Task Created'), true);
                }).catch(function (data, status, headers, config) {
                    Alert.createAlert('danger', $translate('CONTRACTS.Close estimated invoice Task Creation ERROR'), true);
                }).finally(function () {
                    $scope.flagRemitDate = false;
                    $scope.listToUpdate = [];
                    $scope.$parent.loading = false;
                });
            };

            $scope.confirmCloseDate = function () {
                $scope.flagCloseDate = true;
            };

            $scope.updateNo = function () {
                $scope.flagCloseDate = false;
            };
        }
    }
}

export {contractCloseEstimated}
